import { createAction, props } from '@ngrx/store';
import { DataState } from './data.reducer';
import { ExceptionResponse } from '../shared/dto';

export const setDataDarkMode = createAction('@app/data/set/darkMode', props<Pick<DataState, 'darkMode'>>());

export const setDataSidebarCollapsed = createAction('@app/data/set/sidebarCollapsed', props<Pick<DataState, 'sidebarCollapsed'>>());

export const setDataTranslations = createAction('@app/data/set/translations', props<Pick<DataState, 'translations'>>());

export const getDataFailure = createAction('@app/data/get/failure', props<{ error: Error | ExceptionResponse }>());
